import { EMAIL_API } from 'modules/email/api/email-api'
import { EmailTemplateId } from 'modules/email/types/email-template-interface'
import { EmailId } from 'shared/components/dashboard-mail-editor/types/email-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { HTMLString } from 'shared/types/html-string'

export const useChooseEmailTemplate = () => {
  const { fetcher, isFetching } = useFetch<
    RequestMethodsEnum.post,
    { html: HTMLString; id: EmailId }
  >({
    method: RequestMethodsEnum.post,
  })
  return {
    fetcherChooseEmailTemplate: (
      emailId: EmailId,
      data: {
        emailTemplate: EmailTemplateId
      },
    ) => fetcher(`${EMAIL_API}/${emailId}/choose-template`, data),
    isFetchingChooseEmailTemplate: isFetching,
  }
}
